import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { Badge, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import {
   DE_SHUTDOWN_DATE_TEXT,
   EMPLOYER_PORTAL_TRANSITION_URL,
} from 'constants/deprecation';

// Rendered inside nav links — every handler must stop propagation so a click
// on the tag (or inside its modal, which bubbles through the portal in the
// React tree) never triggers the surrounding NavLink navigation or the
// collapsable toggle.
const DeprecatingTag = ({ tagText = 'DEPRECATING' }) => {
   const [isOpen, setIsOpen] = useState(false);

   const handleOpen = useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(true);
   }, []);

   const handleToggle = useCallback((e) => {
      if (e) {
         e.stopPropagation();
      }
      setIsOpen((prevIsOpen) => !prevIsOpen);
   }, []);

   const stopClick = useCallback((e) => {
      e.stopPropagation();
   }, []);

   return (
      <>
         <Badge
            color='danger'
            className='ml-2 align-middle'
            style={{ cursor: 'pointer' }}
            onClick={ handleOpen }
         >
            { tagText }
         </Badge>
         <Modal
            isOpen={ isOpen }
            toggle={ handleToggle }
            className='rounded_modal'
            onClick={ stopClick }
         >
            <button
               type='button'
               className='close modalClose'
               aria-label='Close'
               onClick={ handleToggle }
            >
               <span aria-hidden='true'>&times;</span>
            </button>
            <ModalHeader>
               Direct Employer is retiring
            </ModalHeader>
            <ModalBody>
               This page is part of the Direct Employer portal, which is
               moving to the new Jobcase Employer portal. It will be turned
               off on
               {' '}
               <strong>{ DE_SHUTDOWN_DATE_TEXT }</strong>
               . Please use the new Employer portal for your hiring going
               forward.
            </ModalBody>
            <ModalFooter>
               <a
                  href={ EMPLOYER_PORTAL_TRANSITION_URL }
                  target='_blank'
                  rel='noopener noreferrer'
                  className='btn btn-rounded btn-dark-orange'
               >
                  Go to the new Employer portal
               </a>
            </ModalFooter>
         </Modal>
      </>
   );
};

DeprecatingTag.propTypes = {
   tagText: PropTypes.string,
};

export default DeprecatingTag;
